<template>
	<div>
		<app-header></app-header>
		<div>
			<p v-for="item in list">
		    Line:
		    <span v-text="item"></span>
		  </p>
		  <!--infinite-loading这个组件要放在列表的底部，滚动的盒子里面！-->
            <infinite-loading @infinite="infiniteHandler"></infinite-loading>
        </div>
	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    import InfiniteLoading from 'vue-infinite-loading';
    export default {
        data(){
            return{
                list: [],
            }
        },
        created(){
            
        },
        mounted(){
            
        },
        watch:{
            
        },
        methods: {
        	infiniteHandler($state) {
        		console.log(1);
		     	setTimeout(() => {
		        const temp = [];
		        for (let i = this.list.length + 1; i <= this.list.length + 20; i++) {
		          temp.push(i);
		        }
		        this.list = this.list.concat(temp);
		        $state.loaded();
		      }, 1000);
		    },
        },
        components: {
		    InfiniteLoading,
		},
    }
</script>


// WEBPACK FOOTER //
// Scroll.vue?7388dcb5